<div
  [style.background]="instanceDataOpened() ? 'rgba(0, 0, 0, 0.5)' : 'transparent'"
  class="pt-20 pr-20 pl-24 flex flex-col h-full"
>
  @if (applicationProcessData()) {
    <div
      [class]="!instanceDataOpened() ? 'left-4' : '-left-20'"
      [style.transition]="'left 0.3s ease'"
      [style.z-index]="10000"
      class="flex flex-col absolute bg-white top-5 rounded-lg p-2"
    >
      <a [routerLink]="['/']">
        <button
          pTooltip="Home"
          flxButton
          variant="text"
          icon="center"
          data-testid="navigate-home-btn"
        >
          <img
            class="w-4 h-4"
            flxIcon
            alt="flowx logo"
            src="./assets/logo-small.svg"
          />
        </button>
      </a>
      <button
        (click)="onNavigateToHome()"
        clickStopPropagation
        flxButton
        variant="text"
        icon="center"
      >
        <i
          [class]="appTypeIcon()"
          class="ph w-4 h-4 text-gray-800"
          flxIcon
        ></i>
      </button>
      @if (definitionsExist()) {
        <button
          (click)="onNavigateToProcessDefinition()"
          pTooltip="Go to process definition"
          clickStopPropagation
          flxButton
          variant="text"
          icon="center"
          data-testid="go-to-process-definition-btn"
        >
          <i
            class="ph ph-tree-structure w-4 h-4 text-gray-800"
            flxIcon
          ></i>
        </button>
      }
      @if (processUuid()) {
        <ng-container>
          <button
            #view="cdkOverlayOrigin"
            (click)="showInstanceData()"
            pTooltip="View process instance"
            clickStopPropagation
            cdkOverlayOrigin
            flxButton
            variant="text"
            icon="center"
            data-testid="view-process-instance-btn"
          >
            <i
              class="ph ph-eye w-4 h-4 text-gray-800"
              flxIcon
            ></i>
          </button>
          <ng-template
            [cdkConnectedOverlayOrigin]="view"
            [cdkConnectedOverlayOpen]="instanceDataOpened()"
            [cdkConnectedOverlayOffsetY]="30"
            (detach)="hideInstanceData()"
            cdkConnectedOverlayPanelClass="process-instance-overlay"
            cdkConnectedOverlay
            cdkConnectedOverlayMinHeight="calc(100% - 30px)"
          >
            @if (applicationProcessData()) {
              <div
                class="left-0 bottom-0 h-full w-full bg-white ease-in-out duration-300"
                @fadeIn
              >
                <div
                  [style.z-index]="1007"
                  class="flex justify-end w-full py-2 px-4 bg-white"
                >
                  <button
                    (click)="hideInstanceData()"
                    flxButton
                    icon="center"
                    variant="text"
                    clickStopPropagation
                  >
                    <flx-icon
                      name="close"
                      class="size-4 text-neutral-900"
                    />
                  </button>
                </div>

                <app-process-instance
                  [loading]="loadingApplicationProcessData() && applicationDetailsLoaded()"
                  [applicationProcessData]="applicationProcessData()"
                  [definitionsExist]="definitionsExist()"
                  (navigateToSubProcess)="navigateToSubprocess($event)"
                  (navigateToEmbeddedProcess)="navigateToEmbeddedProcess($event)"
                  (backToParentProcess)="backToParentProcess($event)"
                  class="h-[calc(100%-44px)] block"
                ></app-process-instance>
              </div>
            }
          </ng-template>
        </ng-container>
      }
      <button
        (click)="toggleProcessDefinitionInfoCard()"
        clickStopPropagation
        flxButton
        variant="text"
        icon="center"
        data-testid="info-process-instance-btn"
      >
        <i
          class="ph ph-info w-4 h-4 text-gray-800"
          flxIcon
        ></i>
      </button>
    </div>
  }
  @if (showProcessInfoDetails && applicationProcessData()) {
    <flx-card
      [style.z-index]="1007"
      [style.min-width.px]="300"
      [style.box-shadow]="'0px 4px 24px rgba(0, 0, 0, 0.24)'"
      class="flex flex-col absolute bg-white top-5 left-20 rounded-lg p-2"
      cardStyle="raised"
    >
      <flx-process-instance-info
        [applicationProcessData]="applicationProcessData()"
        [definitionsExist]="definitionsExist()"
        (goToProcessClicked)="onNavigateToProcessDefinition()"
      ></flx-process-instance-info>
    </flx-card>
  }
  <react-wrapper
    [component]="FlxProcessRendererPortal"
    [props]="reactProps()"
    class="flx-process-renderer"
  ></react-wrapper>
</div>
